import api from '@/lib/api';
import { getSharedRefreshAuth } from '@/lib/api';
import { AuthResponse } from '@/types/auth';
import { StorageService } from './storage.service';

export class ApiAuthService {
  async refreshSession(refreshToken: string): Promise<AuthResponse> {
    // Garante um único refresh em voo em toda a aplicação.
    // Evita 401 por reutilização do mesmo refresh token (rotação de token).
    const currentRefresh = StorageService.getRefreshToken();
    if (!currentRefresh && refreshToken) {
      StorageService.setRefreshToken(refreshToken);
    }
    return getSharedRefreshAuth();
  }

  async verifyMagicLink(
    email: string,
    token: string,
    type: string,
  ): Promise<AuthResponse> {
    const response = await api.post<AuthResponse>('/auth/magic-link/verify', {
      email,
      token,
      type,
    });

    return response.data;
  }

  async getGoogleOAuthUrl(redirectTo: string): Promise<string> {
    try {
      const response = await api.get<{ url: string }>('/auth/oauth/google', {
        params: { redirectTo },
      });

      if (!response.data?.url) {
        throw new Error('Failed to get OAuth URL from server');
      }

      return response.data.url;
    } catch (error: any) {
      if (error.response) {
        throw new Error(
          error.response.data?.message ||
            error.response.data?.error ||
            'Failed to get OAuth URL',
        );
      }
      throw error;
    }
  }

  async handleOAuthCallback(
    code: string,
    state?: string,
    redirectUri?: string,
  ): Promise<AuthResponse> {
    const params: Record<string, string> = { code };
    if (state) params.state = state;
    if (redirectUri) params.redirectUri = redirectUri;

    try {
      const response = await api.get<AuthResponse>(
        '/auth/oauth/google/callback',
        { params },
      );
      return response.data;
    } catch (error: unknown) {
      const ax = error as { response?: { data?: { message?: string } } };
      const msg = ax?.response?.data?.message;
      throw new Error(msg || 'Erro ao processar login com Google');
    }
  }

  async verifyMagicLinkSession(
    email: string,
    supabaseId: string,
    name?: string,
    avatar?: string,
  ): Promise<AuthResponse> {
    const response = await api.post<AuthResponse>(
      '/auth/magic-link/verify-session',
      {
        email,
        supabaseId,
        ...(name && { name }),
        ...(avatar && { avatar }),
      },
    );

    return response.data;
  }
}
